<template>
    <div style="margin:0px 0px;">
        <div class="mb-3">          
            <el-collapse>
                <el-collapse-item>
                    <template slot="title">
                        <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                    </template>
                    <el-form label-position="top" label-width="100px">
                        <div class="row">
                       
                            <div class="col-md-4">
                                <el-form-item label="Date">
                                    <el-date-picker
                                        size="small"
                                        v-model="date"
                                        type="daterange"
                                        align="right"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        :start-placeholder="date.Start"
                                        :end-placeholder="date.End"
                                        :default-value="date.End">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div class="col-md-8">
                                <el-form-item label="Period">
                                    <el-radio-group v-model="periode" size="small">
                                        <el-radio-button :label="item6.value" v-for="(item6, index6) in options.periode" :key="item6.value+'_'+index6" style="margin-left:0px;">{{item6.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="Area">
                                    <el-radio-group v-model="area" size="small">
                                        <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <el-button type="success" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                            </div>
                        </div>
                    </el-form>

                </el-collapse-item>
            </el-collapse>
        </div>
        
        <div class="row">
            <div class="col-md-3">
                <el-checkbox v-model="showchart">Show Chart</el-checkbox>
            </div>
            <div class="col-md-4" v-if="showchart">
                <el-radio-group v-model="charttype">
                    <el-radio label="barchart" size="small">Bar Chart</el-radio>
                    <el-radio label="linechart" size="small">Line Chart</el-radio>
                </el-radio-group>
            </div>
            
        </div>
        <div class="mb-3" >
            <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="350" v-if="showchart && charttype=='barchart'" />
            <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
        </div>
        <ReportResultTable :reportname="'PertumbuhanCafeReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess"/>      
    </div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import {Rainbow, Config,Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'


export default
{
	extends:Bright,
	components: {
        ReportResultTable,
        BarChart,
        LineChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    computed:{
	},
    watch:{
        
    },
    mounted(){
        this.loadStoreList()
        this.resumePilihan()
    },
    data() {
		return {
            tabActiveName: 'sales',
            /*
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},*/
            date: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
			urlRequestParams: '',
			options: {
				periode:[
					{ value: '', name: 'ALL' },
					//{ value: 'daily', name: 'DAILY' },
					//{ value: 'weekly', name: 'WEEKLY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "store", name: "BY STORE" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "div", name: "BY DIVISI" }, 
					{ value: "dep", name: "BY DEPARTMENT" },
					{ value: "item", name: "BY ITEM" }
				],
				area:[
					{ value: "", name: "ALL" }, 
					//{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				nfrtype:[
					{ value: "", name: "ALL" }, 
					//{ value: "nfrtype", name: "BY TYPE", field: "BranchType1" },  //name: "BY TYPE"
					{ value: "BRIGHT", name: "STORE" }, 
					{ value: "CAFE", name: "CAFE" }, 
				],
                sltype:[
					//{ value: "", name: "ALL" }, 
					//{ value: "weekly", name: "WEEKLY" }, 
					//{ value: "totalweekly", name: "TOTAL WEEKLY" },
					{ value: "sls", name: "SERVICE LEVEL SUPPLIER" },
                    { value: "slsd", name: "SERVICE LEVEL SUPPLIER DC" },
                    { value: "sld", name: "SERVICE LEVEL DC" },
				],
                sltypeline:[
                    { value: "casefill", name: "CASE FILL" },
                    { value: "linefill", name: "LINE FILL" },
				],
			}, 
            charttype: 'barchart',
			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: false,
			branch: this.$route.query.branch ? this.$route.query.branch : '',
            periode: this.$route.query.period ? this.$route.query.period : 'monthly',
            detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
            detail2: this.$route.query.detail2 ? this.$route.query.detail2 : '',
            area: this.$route.query.area ? this.$route.query.area : '',
			sltype: this.$route.query.sltype ? this.$route.query.sltype : 'sls',
            sltypeline: this.$route.query.sltypeline ? this.$route.query.sltypeline : 'casefill', //'casefill',
            nfrtype: this.$route.query.nfrtype ? this.$route.query.nfrtype : '',
            loading: {
                table: false,
                chart: false,
                isSuccess: false, //is request success or error
            },
        }
    },
    methods:{

        async resumePilihan(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/cafe/pertumbuhanOutlet?' 

			this.urlRequestParams+='&date-range-start='+this.date[0] //this.date.Start
			this.urlRequestParams+='&date-range-end='+this.date[1] //this.date.End
			this.urlRequestParams+='&period='+this.periode
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&nfrtype='+this.nfrtype
			this.urlRequestParams+='&detail='+this.detail1 + '_' + this.detail2
			this.urlRequestParams+='&branch='+this.branch

            //for service level weekly
            this.urlRequestParams+='&count=8' 
            this.urlRequestParams+='&sltype='+this.sltype

			this.loading.table = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    this.loading.isSuccess = true
					this.reportdata = response.data;

                    this.setBarChart(response.data)
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.table = false;
				})
		},

        setBarChart(data) {
            let prefix = "" //WK 
            let label = "legend"
            let legend = "label"
            let valuecol = "Jumlah_store"
            this.chartdata = this.processBarChart(data.data, label, prefix, valuecol, false, legend, "", 1, 2, Rainbow, false, false, false)         
        },

        applyFilter() {
            this.resumePilihan()
        },
    },
}

</script>


<style>
.el-tabs--border-card {
    background: #FFF;
    border: 1px solid #DCDFE6;
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 0%), 0 0 0px 0 rgb(0 0 0 / 0%) !important;
    /* box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%); */
}

.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px !important;
    line-height: 20px !important;
}

label, .form-label {
    font-size: 0.75rem;
    font-weight: 500 !important; /** 700 */
    margin-bottom: 0.0rem !important; /** 0.5rem */
    color: #252f40;
    margin-left: 0.0rem !important;
    /*margin-left: 0.25rem; original*/
}

.el-form-item {
    margin-bottom: 12px !important;
}

.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 100% !important;
}
</style>